export const getStateInterface = () => {
  return {
    appLanguages: null,
    appThemes: null,
    appLayouts: null,
  };
};
